import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Layout from "../../components/Layout/Layout";
import CollectionsHeader from "../../components/ProductCollections/CollectionsHeader";
import CheckoutForm from "../../components/ProductCollections/CheckoutForm";
import OrderSummaryTable from "../../components/ProductCollections/OrderSummaryTable";
import OrderSuccessModal from "../../components/ProductCollections/OrderSuccessModal";
import Button from "../../components/Common/Button";
import LoadingState from "../../components/Common/LoadingState";
import { showErrorToast } from "../../utils/toast";
import { useProductCollectionsData } from "../../hooks/useProductCollectionsData";

const ProductCollectionsCheckout = () => {
    const { t } = useTranslation();
    const [isFormValid, setIsFormValid] = useState(false);
    const {
        navigate,
        selectedIds,
        showSuccess,
        setShowSuccess,
        placedOrderId,
        formData,
        orderItems,
        isLoadingProducts,
        hasLoadedProducts,
        isSubmitting,
        handlePlaceOrder,
        clearSelection,
    } = useProductCollectionsData("checkout");

    useEffect(() => {
        if (selectedIds.length) return;
        showErrorToast(t("PRODUCT_COLLECTIONS_ERROR_SELECT_AT_LEAST_ONE"));
        navigate("/product-collections", { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Layout activeLabel="Product collections">
            <div>
                <CollectionsHeader
                    title={t("PRODUCT_COLLECTIONS_CHECKOUT_TITLE")}
                    subtitle={t("PRODUCT_COLLECTIONS_CHECKOUT_SUBTITLE")}
                    actionLabel={t("COMMON_CANCEL")}
                    onAction={() => navigate("/product-collections")}
                />

                {isLoadingProducts && !hasLoadedProducts ? (
                    <LoadingState message={t("PRODUCT_COLLECTIONS_LOADING_PRODUCTS")} />
                ) : (
                    <div className="mt-8">
                        <CheckoutForm
                            formData={formData}
                            onSubmit={handlePlaceOrder}
                            onBack={() => navigate("/product-collections")}
                            isSubmitting={isSubmitting}
                            hideButton
                            onValidChange={setIsFormValid}
                        />
                        <OrderSummaryTable items={orderItems.map((item) => ({ ...item, qty: 1 }))} />
                        <Button
                            type="submit"
                            form="checkout-form"
                            disabled={!isFormValid || isSubmitting}
                            className="mt-6 w-full"
                        >
                            {isSubmitting ? t("COMMON_SUBMITTING") : t("PRODUCT_COLLECTIONS_COMPLETE_ORDER")}
                        </Button>
                    </div>
                )}
            </div>

            <OrderSuccessModal
                isOpen={showSuccess}
                onClose={() => {
                    setShowSuccess(false);
                    clearSelection();
                    navigate("/product-collections");
                }}
                onViewOrder={() => {
                    setShowSuccess(false);
                    clearSelection();
                    navigate(placedOrderId ? `/gift-orders/${placedOrderId}` : "/gift-orders");
                }}
            />
        </Layout>
    );
};

export default ProductCollectionsCheckout;
